import {FormError} from '@wix/form-viewer'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React, {useState} from 'react'
import {useAppActions, useAppSelector} from '../../../../hooks/runtime'
import {getBuyerDetails, getUseBuyerDetails} from '../../../../selectors/checkout'
import {Checkbox} from '../../../form/commons/checkbox'
import {WixForm} from '../../../wix-form'
import {TicketDetailsFormProps} from './interfaces'
import s from './ticket-details-form.scss'

export const TicketDetailsForm = ({
  formIndex,
  formId,
  lastTicket,
  expanded,
  formValues,
  overrides,
  onChange,
  onRegisterFormHandle,
}: TicketDetailsFormProps) => {
  const {t} = useTranslation()
  const {setUseBuyerDetails, setExpandedTicketIndex} = useAppActions()
  const useBuyerDetails = useAppSelector(getUseBuyerDetails)
  const buyerDetails = useAppSelector(getBuyerDetails)
  const [formErrors, setFormErrors] = useState<FormError[]>([])
  const firstForm = formIndex === 0

  const toggleUseBuyerDetails = () => {
    if (!useBuyerDetails) {
      onChange({...formValues, ...buyerDetails})
      setFormErrors([])
    } else {
      onChange({...formValues, first_name: '', last_name: '', email: ''})
    }

    setUseBuyerDetails({ticketIndex: formIndex, useBuyerDetails: !useBuyerDetails})
  }

  return (
    <div className={expanded ? undefined : s.collapsed}>
      <div className={s.divider} />
      {firstForm && (
        <div className={s.checkbox}>
          <Checkbox
            value={t('mobile.checkout.ticket.useBuyerDetails') as string}
            checked={useBuyerDetails}
            dataHook={DH.SAME_AS_BUYER_CHECKBOX}
            onChange={toggleUseBuyerDetails}
          />
        </div>
      )}
      <div className={s.form}>
        <WixForm
          formId={formId}
          values={formValues}
          errors={formErrors}
          overrides={overrides}
          onChange={onChange}
          onValidate={setFormErrors}
          onRegisterFormHandle={ref => onRegisterFormHandle({...ref, getValues: () => formValues})}
        />
        {!lastTicket && (
          <button className={s.formButton} type="submit" onClick={() => setExpandedTicketIndex(formIndex + 1)}>
            {t('mobile.checkout.ticket.nextTicket')}
          </button>
        )}
      </div>
    </div>
  )
}
